import { render } from "./UniStatsItem.vue?vue&type=template&id=68c49685"
import script from "./UniStatsItem.vue?vue&type=script&lang=js"
export * from "./UniStatsItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__